import { render, staticRenderFns } from "./dispaly-Img.vue?vue&type=template&id=20402a5e&scoped=true"
import script from "./dispaly-Img.vue?vue&type=script&lang=js"
export * from "./dispaly-Img.vue?vue&type=script&lang=js"
import style0 from "./dispaly-Img.vue?vue&type=style&index=0&id=20402a5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20402a5e",
  null
  
)

export default component.exports